export const STARK_MSAL = {
    CLIENT_ID: "e0b3d2cd-37d2-4a7c-a7a9-a410678fbdc3",
    AUTHORITY: "https://b2cstarkdk.b2clogin.com//b2cstarkdk.onmicrosoft.com/B2C_1A_SIGNIN",
    KNOWN_AUTHORITY: ["b2cstarkdk.b2clogin.com"],
    REDIRECT_URI: "https://handvaerkerklub.stark.dk/sso"
}